import { render, staticRenderFns } from "./StaffLink.vue?vue&type=template&id=38d2722a&scoped=true&"
import script from "./StaffLink.vue?vue&type=script&setup=true&lang=js&"
export * from "./StaffLink.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StaffLink.vue?vue&type=style&index=0&id=38d2722a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d2722a",
  null
  
)

export default component.exports